import styled from 'styled-components/macro';

// import theme helpers
import { getBreakpoint, getColor, getFontWeight } from '../../../util/theme';

const ProgramFeaturesItemContent = styled.div`
  flex-basis: 80%;

  padding: 0 0 0 20px;

  h2 {
    font-size: 2.8rem;
    font-weight: ${getFontWeight('medium')};

    display: inline-block;

    padding: 0 0 15px 0;

    position: relative;

    @media (min-width: ${getBreakpoint('lg')}) {
      max-width: 61%;

      &::after {
        content: '';

        position: absolute;
        top: 15px;
        left: ${props => `calc(${props.titleWidth}px + 20px)`};

        background-color: ${getColor('black')};

        height: 2px;

        margin: 0 0 0 20px;

        width: ${props =>
          props.contentWidth && props.titleWidth
            ? `calc(${props.contentWidth}px - ${props.titleWidth}px - 60px)`
            : 'auto'};
      }
    }
  }
`;

export default ProgramFeaturesItemContent;
